export default __webpack_public_path__ + "static/media/cards.67383416.png";